<app-header [headerTitle]="headerTitle"></app-header>
<!-- Header -->

<div class="city-map-view">
  <div class="map-top-header">
    <div class="d-flex align-items-center justify-content-between g-20">
      <div class="dmenu-outer">
        <div class="dmenu" (click)="openSideDropdownOption()">
          <img src="assets/icons/down-arrow-white.svg" alt="" />
        </div>
        <div>
          <ul class="dropdown-options" *ngIf="showDropdown">
            <li (click)="setSelectOption('Favourite')">
              Favorites<svg _ngcontent-cmp-c112="" width="10" height="17" viewBox="0 0 10 17" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path _ngcontent-cmp-c112="" d="M1.39062 1.41052L8.39062 8.41052L1.39062 15.4105" stroke="white"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </li>
            <li (click)="setSelectOption('Journal')">
              Journal<svg _ngcontent-cmp-c112="" width="10" height="17" viewBox="0 0 10 17" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path _ngcontent-cmp-c112="" d="M1.39062 1.41052L8.39062 8.41052L1.39062 15.4105" stroke="white"
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </li>
          </ul>
          <div class="parent-container" [ngSwitch]="selectedOption">
            <ng-container>
              <div class="favorites-modal" *ngSwitchCase="'Favourite'">
                <div class="header mb-2">
                  <h4>Favorites</h4>
                  <button class="close-button" (click)="closeSecondMenu()">
                    <img src="assets/icons/icon-close.svg" alt="" />
                  </button>
                </div>
                <div class="favorites-body" *ngIf="favoriteList && favoriteList.length > 0; else noFavroiteRecords">
                  <div class="form-check-box" *ngFor="let item of favoriteList; let i = index">
                    <div class="form-check-b">
                      <input type="checkbox" value="" id="cb{{ i }}" />
                      <label>{{ item.title }}</label>
                    </div>
                    <span *ngIf="isRemovingFavorite !== item.wp_content_usage_id">
                      <img src="assets/icons/icon-close.svg" alt="" (click)="removeFromFavroite(item)" style="cursor:pointer;" />
                    </span>
                    <span *ngIf="isRemovingFavorite === item.wp_content_usage_id">
                      <div class="spinner-border spinner-border-sm text-light" role="status"></div>
                    </span>
                  </div>
                </div>
                <ng-template #noFavroiteRecords>
                  <p class="text-center text-white mt-3">No favorite records found.</p>
                </ng-template>
              </div>

              <div class="favorites-modal" *ngSwitchCase="'Journal'">
                <div class="header">
                  <h4>JOURNAL</h4>
                  <button class="close-button">
                    <img src="assets/icons/icon-close.svg" alt="" (click)="closeSecondMenu()" />
                  </button>
                </div>
                <div class="favorites-body history-body" *ngIf="
                    historyAllRecords && historyAllRecords.length > 0;
                    else noJournalRecords
                  ">
                  <ng-container *ngFor="
                      let journalEntry of historyAllRecords;
                      let i = index
                    ">
                    <!-- Parent Entry -->
                    <div class="form-check-box">
                      <div class="form-check-b">

                        <div class="title-row">
                          <label (click)="
                              journalEntry.expanded = !journalEntry.expanded;
                              $event.stopPropagation()
                            ">
                            {{ journalEntry.title }}</label>

                          <!-- Expand arrow -->
                          <svg *ngIf="journalEntry.children?.length" class="expand-svg" (click)="
                              journalEntry.expanded = !journalEntry.expanded
                            " [ngClass]="{ rotated: journalEntry.expanded }" width="12" height="12" viewBox="0 0 24 24"
                            fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 8px">
                            <path d="M8 5L15 12L8 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" />
                          </svg>

                          <!-- Edit icon -->
                          <img class="edit-icon" src="assets/icons/icon-edit-white.svg" (click)="
                              editDetail(journalEntry, false);
                              $event.stopPropagation()
                            " />
                        </div>
                      </div>
                    </div>

                    <!-- Child Entries -->
                    <div class="child-entry-box" *ngIf="journalEntry.expanded">
                      <div class="form-check-box child-entry" *ngFor="
                          let child of journalEntry.children;
                          let ci = index
                        ">
                        <div class="form-check-b">
                          <input type="checkbox" id="cb-{{ i }}-{{ ci }}" [value]="child?.id"
                            [(ngModel)]="child.selected" (change)="
                              journalCheckBoxChange(
                                $event,
                                journalEntry.children
                              )
                            " />
                          <label>{{ child.title }}</label>
                          <span>
                            <img src="assets/icons/icon-edit-white.svg" alt="" (click)="
                                editDetail(child, true);
                                $event.stopPropagation()
                              " />
                          </span>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <ng-template #noJournalRecords>
                  <p class="text-center text-white">
                    No journal records found.
                  </p>
                </ng-template>
              </div>

              <div class="gmtool-modal" *ngSwitchCase="'GMTools'">
                <div class="header">
                  <h4>Game Master Tools</h4>
                  <button class="close-button" (click)="closeSecondMenu()">
                    <img src="assets/icons/icon-close.svg" alt="" />
                  </button>
                </div>
                <div class="gmtool-body" *ngIf="backRoute === 'mapview'; else playerGameTools">
                  <p>Expose Map Area</p>
                  <p>Teleport Party Token</p>
                  <p>Expose Whole Map</p>
                  <p (click)="addNote(true)">Private Note</p>
                  <p (click)="addNote(false)">Public Note</p>
                </div>
                <ng-template #playerGameTools>
                  <div class="gmtool-body" *ngIf="this.game_id">
                    <p (click)="openNoteModal(false, true)" class="pointer">
                      GAME MASTER NOTES
                    </p>
                  </div>
                </ng-template>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- map search is not built yet; the box stays hidden until it is -->

      <!-- actions + zoom, top right: one column, every button the same width -->
      <div class="mv-right">
        <div class="mv-actions">
          <button type="button" class="btn btn-green" *ngIf="isAcceptBtn" [disabled]="!startLocation"
            (click)="openGameCreateInvitationModal()"
            [title]="startLocation ? '' : 'Pick a starting spot on the map first'">Accept</button>
          <button type="button" class="btn btn-outline" (click)="onExitCity($event)" *ngIf="isLoadToken"
            [class.is-inactive]="!isMovable || !atBoundary" [attr.aria-disabled]="!isMovable || !atBoundary"
            [title]="!isMovable || !atBoundary ? 'Move the party token to the edge of the city to leave' : ''">Exit city</button>
          <button type="button" class="btn btn-dark" (click)="handleOnlyBack()">Main map</button>
          <button type="button" class="btn btn-outline" (click)="handleMapviewExit()">{{ isAcceptBtn ? 'Cancel' : 'Exit' }}</button>
        </div>
        <div class="btn-map-icon">
          <button type="button" class="btnmap" (click)="triggerTokenZoom()" [disabled]="!isLoadToken"
            title="Go to the party token" aria-label="Go to the party token">
            <img src="assets/icons/icon-map-location.svg" alt="" />
          </button>
          <button type="button" class="btnmap" (click)="triggerZoomIn()" title="Zoom in" aria-label="Zoom in">
            <img src="assets/icons/icon-map-plus.svg" alt="" />
          </button>
          <button type="button" class="btnmap" (click)="triggerZoomOut()" title="Zoom out" aria-label="Zoom out">
            <img src="assets/icons/icon-map-minus.svg" alt="" />
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="mapdetail-box" [class.open]="sideInfoBar" [class.hidden]="!sideInfoBar" #sideContent *ngIf="mapcode">
    <h4 class="mapdetail-header" (click)="toggleMapDetails()" role="button" [attr.aria-expanded]="isMapDetailsVisible">
      MAP DETAILS
      <i class="fa" [ngClass]="isMapDetailsVisible ? 'fa-angle-down' : 'fa-angle-up'" style="margin-left: auto;"></i>
    </h4>

    <ul *ngIf="isMapDetailsVisible">
      <li *ngIf="map_name">
        World:&nbsp;
        <span class="pointer pointer-cursor-link pl-2" (click)="navigateToWikiWorld(map_name)">{{ map_name || "Unnamed Map"
          }}</span>
      </li>
      <ng-container *ngIf="objectData; else elseBlockNoData">
        <ng-container *ngFor="let property of objectData | keyvalue: cellDetailsSort">
          <ng-container *ngIf="property.key !== 'id' && property.key !== 'burgs_data'">
            <li [class.bdr-top]="property.key === 'State' || property.key === 'Natural Resources'">
              {{ property.key }}:&nbsp;

              <!-- Render resources as links if applicable -->
              <ng-container *ngIf="isResourceField(property.key); else normalLink">
                <ng-container *ngIf="splitResources(property.value)?.length > 0; else None">
                  <ng-container *ngFor="
                      let item of splitResources(property.value);
                      let i = index
                    ">
                    <div href="#" class="pointer pointer-cursor-link pl-2"
                      (click)="onResourceClick(item.name || item)"
                      (mouseenter)="showResourceTooltip($event, item)"
                      (mouseleave)="hideResourceTooltip()">
                      {{ item.name || item }}
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #None>
                  <span> None</span>
                </ng-template>
              </ng-container>

              <!-- Fallback: normal value -->
              <ng-template #normalLink>
                <ng-container *ngIf="isLinkField(property.key); else normalValue">
                  <ng-container *ngIf="property?.value; else noValue">
                    <div class="pointer pointer-cursor-link pl-2" (click)="
                        navigateToDynamicLink(property.key, property.value)
                      ">
                      {{ property.value }}
                    </div>
                  </ng-container>
                  <ng-template #noValue>
                    <span>None</span>
                  </ng-template>
                </ng-container>
              </ng-template>
              <ng-template #normalValue>
                <span> {{ property.value }}</span>
              </ng-template>
            </li>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-template #elseBlockNoData>
        <li>No cell selected</li>
      </ng-template>
    </ul>
  </div>

  <div class="city-detail-box">
    <h4 class="mapdetail-header" (click)="isCityDetailsVisible = !isCityDetailsVisible" role="button" [attr.aria-expanded]="isCityDetailsVisible">
      CITY details
      <i class="fa" [ngClass]="isCityDetailsVisible ? 'fa-angle-down' : 'fa-angle-up'" style="margin-left: auto;"></i>
    </h4>

    <ul *ngIf="isCityDetailsVisible">
      <ng-container *ngIf="cityData; else elseBlock">
        <ng-container *ngFor="let property of cityData | keyvalue: cityDetailsSort">
          <ng-container *ngIf="property.key == 'City Name'; else normalKeyValue">
            <li (click)="navigateToCityNameWiki()">
              {{ property.key }}:
              <span class="pointer pointer-cursor-link pl-2">{{ property.value }}
              </span>
            </li>
          </ng-container>
          <ng-template #normalKeyValue>
            <li>{{ property.key }}: {{ property.value }}</li>
          </ng-template>
        </ng-container>
      </ng-container>
      <ng-template #elseBlock>
        <li>No city selected</li>
      </ng-template>
    </ul>
  </div>
</div>
<!-- Map Container -->
<div id="map1" class="map-container" #cityMap (contextmenu)="onRightClickPopup($event)"></div>

<!-- right-click menu: what to do at this spot -->
<div class="map-ctx" *ngIf="showMenu" [style.top.px]="menuPosition.y" [style.left.px]="menuPosition.x" role="menu">
  <div class="map-ctx-head">
    <span>At this spot</span>
    <button type="button" class="map-ctx-close" (click)="showMenu = false" aria-label="Close"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>
  </div>
  <button type="button" class="map-ctx-item" role="menuitem" (click)="createContent()"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span>Create new content</span></button>
  <button type="button" class="map-ctx-item" role="menuitem" (click)="browseWpStore()"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M4 9h16l-1.2 10.2a1 1 0 0 1-1 .8H6.2a1 1 0 0 1-1-.8L4 9Zm4 0V7a4 4 0 0 1 8 0v2" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg><span>Browse store content</span></button>
  <button type="button" class="map-ctx-item" role="menuitem" (click)="openPlaceContentModal()"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="M4 7h16v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7Zm-1-3h18v3H3V4Zm6 7h6" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round"/></svg><span>Add from your vault</span></button>
</div>

<!-- Footer (Add if needed) -->
<!-- no site footer on the play screen: the map uses the whole window -->

<!-- Resource Hover Tooltip Card -->
<div class="resource-hover-card" *ngIf="hoveredResource" [ngStyle]="tooltipStyle">
  <div class="resource-card-arrow"></div>
  <h4 class="resource-card-title">{{ hoveredResource.name }}</h4>
  <p class="resource-card-desc" *ngIf="hoveredResource.description">
    {{ hoveredResource.description }}
  </p>
  <div class="resource-card-metrics" *ngIf="hoveredResource.production !== undefined || hoveredResource.economy !== undefined || hoveredResource.rarity !== undefined || hoveredResource.processing !== undefined">
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.production || 0 }}</div>
      <div class="metric-label">Production</div>
    </div>
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.economy || 0 }}</div>
      <div class="metric-label">Economy</div>
    </div>
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.rarity || 0 }}</div>
      <div class="metric-label">Rarity</div>
    </div>
    <div class="metric-item">
      <div class="metric-value">{{ hoveredResource.processing || 0 }}</div>
      <div class="metric-label">Processing</div>
    </div>
  </div>
</div>

<!-- Footer content goes here -->